export const getInitialRowsData = (items: any[], isWidgetData: boolean, groupByLevels: boolean) => {
	if (groupByLevels) {
		const groupedData = groupDataByLevels(items);
		return groupedData;
	}

	if (isWidgetData) {
		return items.map((item) => {
			return {
				...item,
				expanded: false,
				hasChildren: item.children && item.children.length > 0,
				level: 0
			}
		});
	}

	const filteredItems = items.filter((item) => item.parentId === undefined);
	return filteredItems.map((item) => {
		return {
			...item,
			expanded: false,
			hasChildren: items.some(child => child.parentId === item.id),
			level: 0
		}
	});
}

export const getExpandedRowsData = (rootItems: any[], items: any[], expandedItem: any, isWidgetData: boolean, groupByLevels: boolean) => {
	if (groupByLevels) {
		const updatedItems = rootItems.map((item) => {
			if (item.groupId === expandedItem.groupId) {
				return {
					...item,
					expanded: true
				};
			}
			return item;
		});

		const childrenToAdd = expandedItem.children.map((child) => {
			return {
				...child,
				expanded: false,
				hasChildren: child.children && child.children.length > 0,
				level: expandedItem.level + 1
			}
		});

		const parentIndex = updatedItems.findIndex((item) => item.groupId === expandedItem.groupId);

		const newExpandedData = [
			...updatedItems.slice(0, parentIndex + 1),
			...childrenToAdd,
			...updatedItems.slice(parentIndex + 1)
		];

		return newExpandedData;
	}

	if (isWidgetData) {
		const updatedItems = rootItems.map((item) => {
			if (item.date === expandedItem.date) {
				return {
					...item,
					expanded: true
				}
			}

			return item;
		});

		const childrenToAdd = expandedItem.children.map((child) => {
			return {
				...child,
				expanded: false,
				hasChildren: child.children && child.children.length > 0,
				level: expandedItem.level + 1
			}
		});

		const parentIndex = updatedItems.findIndex((item) => item.date === expandedItem.date);

		const newExpandedData = [
			...updatedItems.slice(0, parentIndex + 1),
			...childrenToAdd,
			...updatedItems.slice(parentIndex + 1),
		];

		return newExpandedData;
	}

	const updatedItems = rootItems.map((item) => {
		if (item.id === expandedItem.id) {
			return {
				...item,
				expanded: true
			}
		}

		return item;
	});

	const childrenToAdd = items.filter(child => child.parentId === expandedItem.id && !rootItems.some(item => item.id === child.id)).map((child) => {
		return {
			...child,
			expanded: false,
			hasChildren: items.some(grandChild => grandChild.parentId === child.id),
			level: expandedItem.level + 1
		}
	});

	const parentIndex = updatedItems.findIndex(item => item.id === expandedItem.id);

	const newExpandedData = [
		...updatedItems.slice(0, parentIndex + 1),
		...childrenToAdd,
		...updatedItems.slice(parentIndex + 1),
	];

	return newExpandedData;
}

export const getCollapsedRowsData = (items: any[], collapsedItem: any, isWidgetData: boolean, groupByLevels: boolean) => {
	if (groupByLevels) {
		const updatedItems = items.map((item) => {
			if (item.groupId === collapsedItem.groupId) {
				return {
					...item,
					expanded: false
				};
			}
			return item;
		});

		const expandedChildren = getAllExpandedGroupChildren(collapsedItem);

		const newCollapsedData = updatedItems.filter(item => !expandedChildren.some(child => child.groupId === item.groupId));

		return newCollapsedData;
	}

	if (isWidgetData) {
		const updatedItems = items.map((item) => {
			if (item.date === collapsedItem.date) {
				return {
					...item,
					expanded: false
				};
			}

			return item;
		});

		const expandedChildren = collapsedItem.children || [];

		const newCollapsedData = updatedItems.filter(item => !expandedChildren.some(child => child.date === item.date));

		return newCollapsedData;
	}

	const updatedItems = items.map((item) => {
		if (item.id === collapsedItem.id) {
			return {
				...item,
				expanded: false
			};
		}

		return item;
	});

	const expandedChildren = getAllExpandedChildren(collapsedItem, items);

	const newCollapsedData = updatedItems.filter(item => !expandedChildren.some(child => child.id === item.id));

	return newCollapsedData;
}

const getAllExpandedChildren = (parentItem: any, items: any[]) => {
	const allChildren: any[] = [];

	const findChildren = (parentId: any) => {
		const children = items.filter(item => item.parentId === parentId);
		for (const child of children) {
			allChildren.push(child);
			findChildren(child.id);
		}
	}

	findChildren(parentItem.id);

	return allChildren;
}

const getAllExpandedGroupChildren = (parentItem: any) => {
	const allChildren: any[] = [];

	const findChildren = (parent: any) => {
		if (parent.children && parent.children.length > 0) {
			for (const child of parent.children) {
				allChildren.push(child);
				findChildren(child);
			}
		}
	}

	findChildren(parentItem);

	return allChildren;
}

export const handleExpandRows = (currentRows: any[], items: any[], targetLevel: number) => {
	const rootItems = currentRows.filter(item => item.level === 0 && item.parentId === undefined);
	const expandedRows: any[] = [];

	const expandRowsToLevel = (rows: any[], currentLevel: number) => {
		for (const row of rows) {
			const newRow = {
				...row,
				expanded: currentLevel < targetLevel,
				hasChildren: items.some(child => child.parentId === row.id),
				level: currentLevel
			};
			expandedRows.push(newRow);

			if (currentLevel < targetLevel && newRow.expanded && newRow.hasChildren) {
				const childRows = items.filter(child => child.parentId === newRow.id);
				expandRowsToLevel(childRows, currentLevel + 1);
			}
		}
	};

	expandRowsToLevel(rootItems, 0);

	return expandedRows;
}

export const collapseAllRows = (items: any[]) => {
	return items.filter(item => item.level === 0).map(item => {
		return {
			...item,
			expanded: false
		}
	});
}

const groupDataByLevels = (data: any[]) => {
	const result: any[] = [];

	const createGroup = (groupId: string, groupLevel: string, groupName: string, level: number, parent: any[], hasChildren: boolean, hasDiagram: boolean) => {
		let group = parent.find(g => g.groupId === groupId);

		if (!group) {
			group = {
				groupId,
				groupLevel,
				groupName,
				children: [],
				expanded: false,
				hasChildren,
				hasDiagram,
				level,
				itemCount: 0
			};
			parent.push(group);
		}

		group.itemCount++;
		return group;
	}

	for (const item of data) {
		const {
			level1Id, level1Name, level1Description, level1HasDiagram,
			level2Id, level2Name, level2Description, level2HasDiagram,
			id, processId, level3Name, level3Description, level3HasDiagram,
			level4Id, level4Name, processDescription
		} = item;

		// Level 1 group
		const level1GroupId = `${level1Id}`;
		const level1GroupName = `${level1Name}: ${level1Description}`;
		let level1 = createGroup(level1GroupId, 'Level 1', level1GroupName, 0, result, true, level1HasDiagram);

		// Level 2 group
		const level2GroupId = `${level2Id}`;
		const level2GroupName = `${level2Name}: ${level2Description}`;
		let level2 = createGroup(level2GroupId, 'Level 2', level2GroupName, 1, level1.children, true, level2HasDiagram);

		// Level 3 group
		const level3GroupId = `${id}`;
		const level3GroupName = `${level1Name}-${level2Name}-${level3Name}: ${level3Description}`;
		let level3 = createGroup(level3GroupId, 'Level 3', level3GroupName, 2, level2.children, !!(level4Id && level4Name), level3HasDiagram);

		if (level4Id && level4Name) {
			const hasFirstItem = level3.children.length > 0;

			const level4Item = {
				...item,
				level1Name: hasFirstItem ? '' : level1Name,
				level1Description: hasFirstItem ? '' : level1Description,
				level2Name: hasFirstItem ? '' : level2Name,
				level2Description: hasFirstItem ? '' : level2Description,
				level3Name: hasFirstItem ? '' : level3Name,
				level3Description: hasFirstItem ? '' : level3Description,
				processId: hasFirstItem ? '' : processId,
				processDescription: hasFirstItem ? '' : processDescription,
			};
			level3.children.push(level4Item);
		}

		// Check if Level 3 has no children, if not, add item as its child
		if (level3.children.length === 0) {
			level3.children.push(item);
		}
	}

	return result;
}
